<template>
    <div>
        <div class="mb-3">
            <v-row justify="space-around">
                <v-spacer/>
                <v-checkbox label="Actifs" v-model="filters.active"/>
                <v-spacer/>
                <v-select :items="serviceListWithAll" v-model="filters.service" hide-details label="Service"/>
                <v-spacer/>
            </v-row>
        </div>
        <v-data-table
                :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50, 100]}"
                :headers="headers"
                :items="items"
                :items-per-page="50"
                :loading="loading"
                :options.sync="options"
                :server-items-length="totalItems"
                @click:row="$emit('token-selected',$event)"
        >
            <template v-slot:item.role="{ item }">
                <div v-if="item.scopedAuthorizations.length">
                    <div :key="i+'a'" v-for="(v,i) in item.scopedAuthorizations">
                        <pre v-html="v.authorization.role" v-if="v.authorization && v.authorization.role"/>
                        <pre-shortener v-if="v.authorization && v.authorization.grants"
                                       v-model="v.authorization.grants"/>
                        <span v-if="!v.authorization">-</span>
                    </div>
                </div>
                <span v-else>-</span>
            </template>
            <template v-slot:item.branchUuid="{ item }">
              <y-branch-label :key="i+'b'" v-for="(v,i) in item.scopedAuthorizations" v-model="v.scope.branchUuid"/>
            </template>
            <template v-slot:item.companyUuid="{ item }">
              <y-company-label :key="i+'b'" v-for="(v,i) in item.scopedAuthorizations" v-model="v.scope.companyUuid"/>
            </template>
            <template v-slot:item.maskedTokenString="{ item }">
                <pre-shortener v-model="item.maskedTokenString"/>
            </template>

        </v-data-table>
        <v-snackbar :bottom="true" :timeout="0" color="error" v-model="error">
            Une erreur est survenue. Veuillez réessayer, ou contacter l'équipe de support de Yodatech
            <v-btn @click="refresh" dark text>Réessayer</v-btn>
        </v-snackbar>
        <v-snackbar :bottom="true" :timeout="5000" color="error" v-model="downloadError">
            Une erreur est survenue. Veuillez réessayer, ou contacter l'équipe de support de Yodatech
            <v-btn @click="downloadError = false" dark text>Fermer</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import PreShortener from "./PreShortener";
import {mapActions, mapGetters} from 'vuex'

export default {
		name: "TokenTable",
		components: {PreShortener},
		data() {
			return {
				headers: [
					{text: "Service", value: "serviceName"},
					{text: "Agences", value: "branchUuid", sortable: false},
					{text: "Sociétes", value: "companyUuid", sortable: false},
					{text: "Accréditations", value: "role", sortable: false},
					{text: "Commentaire", value: "label"},
					{text: "Token masqué", value: "maskedTokenString"},
				],
				filters: {
					active: true,
					service: "all"
				},
				items: [],
				loading: false,
				options: {},
				totalItems: 0,
				error: false,
				downloadError: false
			}
		},
		watch: {
			options: {
				handler() {
					this.refresh();
				},
				deep: true,
			},
			filters: {
				handler() {
					this.options.page = 1;
					this.refresh();
				},
				deep: true,
			},
		},
		computed: {
			...mapGetters('services', ['serviceListWithAll'])
		},
		mounted() {
			this.refresh();
			this.fetchServices();
		},
		methods: {
			...mapActions('services', ['fetchServices']),
			refresh() {
				this.loading = true;
				this.error = false;
				const {sortBy, sortDesc, page, itemsPerPage} = this.options;

				let url = this.$config.apiUrl + "/v2/services/";
				url += this.filters.service ? this.filters.service : "all";
				url += "/tokens?page=" + (page - 1) + "&size=" + itemsPerPage;
				if (sortBy.length) {
					url += "&sort=" + sortBy[0] + "," + (sortDesc[0] ? 'desc' : 'asc');
				}
				url += "&active=" + (this.filters.active ? "true" : "false");

				this.$http.get(url)
					.then(r => {
						this.items = r.data.content;
						this.totalItems = r.data.totalElements;
					})
					.catch((e) => this.error = true)
					.finally(() => this.loading = false)
			}
		}
	}
</script>

<style scoped>

</style>
